"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Container = _interopRequireDefault(require("./components/Container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SlackPreferences = function SlackPreferences(props) {
  var newPreferences = props.newPreferences,
      setNewPreferences = props.setNewPreferences,
      slackEmail = props.slackEmail,
      setSlackEmail = props.setSlackEmail,
      getSlackUserFromEmail = props.getSlackUserFromEmail,
      updateSlackPreferences = props.updateSlackPreferences,
      updateDisabled = props.updateDisabled,
      preferences = props.preferences;
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    Title: "Slack Preferences"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-y-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-y-3"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "block font-bold"
  }, "Send Messages to Slack"), /*#__PURE__*/_react["default"].createElement(_avlComponents.BooleanInput, {
    value: newPreferences.receiveSlack,
    onChange: setNewPreferences
  })), !newPreferences.receiveSlack ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "slackEmail",
    className: "block font-bold"
  }, "Slack Email"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "email",
    id: "slackEmail",
    placeholder: "Enter your slack email...",
    onChange: setSlackEmail,
    value: slackEmail
  })), /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonLargeInfoBlock",
    onClick: getSlackUserFromEmail,
    disabled: !slackEmail
  }, "check slack email"))), !(preferences.slackUserId && newPreferences.receiveSlack) ? null : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", {
    className: "block font-bold"
  }, "Slack User ID"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    readOnly: true,
    value: preferences.slackUserId
  })), /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    buttonTheme: "buttonLargePrimaryBlock",
    onClick: updateSlackPreferences,
    disabled: updateDisabled
  }, "update preferences")));
};

var slackPreferences = {
  type: SlackPreferences,
  wrappers: ["show-loading", "ams-slack-preferences"]
};
var _default = slackPreferences;
exports["default"] = _default;